/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EvaluationsWithRelations } from './evaluationsWithRelations';
import { RelationTypesWithRelations } from './relationTypesWithRelations';


/**
 * (tsType: EvaluationScoresWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EvaluationScoresWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    evaluationId?: string;
    relationTypeId?: string;
    score: number;
    scoreDisplay: number;
    evaluations?: EvaluationsWithRelations;
    relationTypes?: RelationTypesWithRelations;
}

